import PasswordForm from "./PasswordForm";
import {useContext} from "react";
import {MyContext} from "../context/myContext";

const PasswordChangeBox = () => {
    const {showUserPasswordForm, showTopMenuPasswordForm, handleShowForm} = useContext(MyContext)
    return(
        <div className={`${(showTopMenuPasswordForm || showUserPasswordForm) && 'show-password-box'} password-box`}>
            <div className="top-section">
                <i className="fa fa-times close-icon" onClick={handleShowForm}></i>
                <span className='title'>تغییر رمز عبور</span>
            </div>
            <PasswordForm />
        </div>
    )
}

export default PasswordChangeBox